export const environment = {
    production: true,
    apiUrl: '/api',
    adminUrl: '/admin/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts